
import Vue from "vue";
import errorService from "@/services/errorService";

export default Vue.extend({
  props: ['error', 'isSystemError', 'iconClasses', 'subError', 'systemErrorMessage'],
  name: "ErrorCard",
  data() {
    return {
      errorService,
      alertShown: false,
      alertOptions: {
        title: this.$t('ERROR_SERVICE.ERROR_DETAIL'),
        cancel: this.$t('APP.CLOSE'),
        titleClasses: 'font-18'
      }
    }
  },
  methods: {
    alertClose() {
      this.alertShown = false;
    },
    showDetail() {
      this.alertShown = true;
    },
  }
})
